import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { useTheme } from '@mui/material/styles';
import JiraIcon from '../../../../../NRIcons/IntegrationIcons/JiraIcon';
import NetRisePlainLogo from '../../../../../NRIcons/NetRisePlainLogo';
import { JIRA_SETUP_MODAL_LABELS } from '../jiraSetup.constants';

function NRJiraSetupConnectionHeader({ heading = JIRA_SETUP_MODAL_LABELS.HEADING }) {
  const theme = useTheme();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={theme.spacing(2)} mb={theme.spacing(3)}>
      <Box display="flex" alignItems="center" gap={theme.spacing(2)}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: theme.spacing(7),
            height: theme.spacing(7),
            borderRadius: theme.spacing(1),
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper
          }}
        >
          <JiraIcon height="42" width="46" />
        </Box>
        <SwapHorizIcon sx={{ color: theme.palette.text.secondary }} aria-hidden />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: theme.spacing(7),
            height: theme.spacing(7),
            borderRadius: theme.spacing(1),
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper
          }}
        >
          <NetRisePlainLogo color={theme.palette.primary.main} height="42" width="48" />
        </Box>
      </Box>
      <Typography variant="h3" color="textPrimary" textAlign="center">
        {heading}
      </Typography>
    </Box>
  );
}

export default NRJiraSetupConnectionHeader;
